{
  "OPTIONAL": "Opcjonalny",
  "BOOLEAN": {
    "YES": "Tak",
    "NO": "Nie"
  },
  "URGENCY": {
    "HIGH": "Wysoka",
    "LOW": "Niska"
  },
  "APP": {
    "VERSION": "Wersja aplikacji: {version}"
  },
  "BUTTONS": {
    "NEXT": "Dalej",
    "SKIP": "Pomiń",
    "CONFIRM": "Potwierdź",
    "CLOSE": "Zamknij",
    "CANCEL": "Anuluj",
    "SHOW_ALL": "Pokaż wszystkie",
    "HIDE": "Ukryj"
  },
  "FOOTER": {
    "HOME": "Główna",
    "WORK": "Praca",
    "TOOLBOXES": "Narzędzia",
    "PROFILE": "Profil"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Brak projektów",
    "EMPTY_STATE_MESSAGE": "Projekty pojawią się wkrótce."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Zameldowany",
      "CHECKED_OUT": "Wymeldowany",
      "CHECK_IN": "Zamelduj się",
      "CHECK_OUT": "Wymelduj się"
    },
    "TO_FULFILL": "Do zrealizowania",
    "CHECKLISTS": "Listy kontrolne",
    "CERTIFICATES": "Certyfikaty",
    "SAFETY_INSTRUCTIONS": "Instrukcje bezpieczeństwa",
    "TOOLBOXES": "Toolboxy",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Brak aktywnego projektu",
      "MESSAGE": "Nie jesteś jeszcze zarejestrowany w projekcie. Znajdź projekt, aby rozpocząć!",
      "BUTTON": "Znajdź projekt"
    },
    "ALERTS": "Wiadomości",
    "NO_ALERTS": "Obecnie nie ma wiadomości",
    "CURRENT_CHECK_IN": "Obecnie zameldowany",
    "LAST_PROJECT": "Ostatni projekt",
    "CHECKED_IN_AT": "Zameldowany o {time}",
    "LAST_CHECKED_IN": "Ostatnio zameldowany o {time}",
    "CHECKED_OUT_AT": "Wymeldowany o {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Pracownicy na budowie",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Utwórz"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Instrukcje bezpieczeństwa",
    "ALL_COMPLETED": "Wszystkie wymagane instrukcje bezpieczeństwa zostały ukończone"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Poprzednia",
    "NEXT": "Następna",
    "FINISH": "Zakończ",
    "QUESTION_HINT_AT_LEAST_ONE": "Proszę wybrać co najmniej jedną poprawną odpowiedź",
    "QUESTION_HINT_ALL_CORRECT": "Proszę wybrać wszystkie poprawne odpowiedzi",
    "QUESTION_ERROR_ALL_CORRECT": "To nie są poprawne odpowiedzi, spróbuj ponownie",
    "QUESTION_CORRECT": "Poprawna odpowiedź!",
    "QUESTION_ERROR_UNANSWERED": "Proszę podać poprawne odpowiedzi na wszystkie pytania przed kontynuowaniem"
  },
  "LOGIN": {
    "EMAIL_LABEL": "E-mail",
    "PASSWORD_LABEL": "Hasło",
    "EMAIL_PLACEHOLDER": "Wpisz swój adres e-mail",
    "PASSWORD_PLACEHOLDER": "Wpisz swoje hasło",
    "LOGIN_BUTTON": "Zaloguj się",
    "LOG_IN": "Zaloguj się",
    "FORGOT_PASSWORD": "Zapomniałeś hasła?",
    "LOGIN_WITH_YIVI": "Zaloguj się za pomocą Yivi",
    "YIVI_HELP": "Użyj Yivi, aby zalogować się lub utworzyć konto.",
    "PASSWORD_LOGIN": "Logowanie za pomocą hasła"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Zapomniałeś hasła",
    "DESCRIPTION": "Wpisz swój adres e-mail, abyśmy mogli wysłać Ci e-mail do odzyskania hasła",
    "EMAIL_LABEL": "E-mail",
    "EMAIL_PLACEHOLDER": "Wpisz swój adres e-mail",
    "SUCCESS_MESSAGE_1": "Wysłaliśmy e-mail potwierdzający na",
    "SUCCESS_MESSAGE_2": "Sprawdź swój e-mail i kliknij link potwierdzający, aby kontynuować",
    "SUBMIT_BUTTON": "Wyślij",
    "RESEND_BUTTON": "Wyślij ponownie e-mail"
  },
  "RESET_PASSWORD": {
    "TITLE": "Resetuj hasło",
    "DESCRIPTION": "Stwórz nowe, silne hasło, którego nie używasz na innych stronach",
    "PASSWORD_LABEL": "Nowe hasło",
    "PASSWORD_PLACEHOLDER": "Wpisz swoje nowe hasło",
    "VERIFY_PASSWORD_LABEL": "Potwierdź nowe hasło",
    "VERIFY_PASSWORD_PLACEHOLDER": "Wpisz ponownie swoje nowe hasło",
    "PASSWORD_MISMATCH": "Hasła nie pasują do siebie",
    "RESET_BUTTON": "Resetuj hasło",
    "INVALID_TOKEN": "Adres e-mail jest nieprawidłowy lub token wygasł. Zresetuj hasło ponownie.",
    "SUCCESS_TITLE": "Sukces!",
    "SUCCESS_MESSAGE": "Twoje hasło zostało pomyślnie zresetowane. Możesz się teraz zalogować używając nowego hasła.",
    "LOGIN": "Zaloguj się",
    "INVALID_LINK_TITLE": "Nieprawidłowy link resetowania",
    "INVALID_LINK_MESSAGE": "Ten link resetowania hasła jest nieprawidłowy lub wygasł. Zresetuj hasło ponownie.",
    "REQUEST_NEW_LINK": "Poproś o nowy link resetowania"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Zaproszenie",
      "DESCRIPTION": "Masz zaproszenie do zatrudnienia. Sprawdź szczegóły i zaakceptuj, aby rozpocząć.",
      "SUBSCRIPT": "Ten link zaproszenia można użyć tylko raz i wygasa za 7 dni.",
      "BUTTON": "Zaakceptuj zaproszenie"
    },
    "OFFER": {
      "ORGANISATION": "Organizacja",
      "FUNCTION": "Funkcja",
      "START_DATE": "Data rozpoczęcia",
      "END_DATE": "Data zakończenia",
      "INVITED_AS": "Zaproszono jako"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Zaakceptuj na telefonie",
      "DESCRIPTION": "Zeskanuj ten kod aparatem telefonu, aby otworzyć to zaproszenie w aplikacji i-LOP."
    },
    "SIGN_IN_TO_ACCEPT": "Zaloguj się, aby zaakceptować",
    "SUCCESS": {
      "TITLE": "Zaproszenie zaakceptowane!",
      "DESCRIPTION": "Twoje zatrudnienie jest teraz powiązane z Twoim kontem.",
      "BUTTON": "Kontynuuj"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Już zaakceptowane",
      "DESCRIPTION": "To zaproszenie zostało już zaakceptowane."
    },
    "NOT_INVITABLE": {
      "TITLE": "Zaproszenie nie jest już aktualne",
      "DESCRIPTION": "To zatrudnienie nie jest już dostępne. Skontaktuj się z pracodawcą."
    },
    "EXPIRED": {
      "TITLE": "Zaproszenie wygasło",
      "DESCRIPTION": "Ten link zaproszenia wygasł. Poproś swojego pracodawcę o wysłanie nowego zaproszenia."
    },
    "INVALID_LINK": {
      "TITLE": "Nieprawidłowy link zaproszenia",
      "DESCRIPTION": "Ten link zaproszenia jest nieprawidłowy. Skontaktuj się z administratorem, aby poprosić o nowe zaproszenie."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "Adres e-mail jest już używany",
      "INVALID": "Twój adres e-mail lub hasło jest nieprawidłowe",
      "TRY_LATER": "Nie możesz się zalogować w tym momencie, spróbuj ponownie później",
      "TOKEN_NOT_VALID": "Musisz się zalogować ponownie",
      "YIVI_FAILED": "Wystąpił błąd podczas logowania z Yivi"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Jesteś już przypisany do tego projektu.",
      "NOT_ASSIGNED": "Nie jesteś przypisany do tego projektu."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Brak uprawnień do użycia aparatu",
      "INVALID": "Kod QR jest nieprawidłowy",
      "EXPIRED": "Kod QR wygasł",
      "NO_PROJECT_SELECTED": "Najpierw wybierz projekt, dla którego chcesz weryfikować",
      "NO_PROJECT_TO_VERIFY": "Nie prowadzisz tu żadnego projektu, więc nie ma projektu, dla którego można zweryfikować tego pracownika",
      "PROJECTS_UNAVAILABLE": "Nie udało się wczytać Twoich projektów. Sprawdź połączenie i zeskanuj ponownie",
      "IDENTITY_NOT_RESOLVED": "Kod QR nie odpowiada jednemu kontu w aplikacji"
    },
    "AVATAR": {
      "TOO_LARGE": "Plik zdjęcia jest za duży. Wybierz mniejsze zdjęcie.",
      "DIMENSIONS_TOO_LARGE": "Zdjęcie jest za duże. Wybierz mniejsze zdjęcie.",
      "UNSUPPORTED_IMAGE_TYPE": "Tego typu pliku nie można użyć jako zdjęcia profilowego. Wybierz obraz JPEG, PNG lub WebP.",
      "MALFORMED_IMAGE": "Nie udało się odczytać zdjęcia. Wybierz inne zdjęcie.",
      "INVALID_IMAGE": "Tego zdjęcia nie można użyć jako zdjęcia profilowego."
    },
    "GENERIC": "Coś poszło nie tak",
    "NETWORK": "Nie można połączyć się z serwerem",
    "NOT_FOUND": "Nie można niczego znaleźć",
    "UNKNOWN": "Wystąpił nieznany błąd",
    "OFFLINE": "Nie jesteś online",
    "NOT_CHECKED_IN": "Nie jesteś zameldowany w projekcie",
    "CONTENT_OUTSTANDING": "Ukończ wszystkie instrukcje i toolboxy przed podpisaniem.",
    "INVALID_SIGNATURE": "Nie udało się odczytać podpisu. Narysuj go ponownie.",
    "NO_PROJECT_ACCESS": "Nie masz dostępu do tego projektu",
    "NO_ACCESS": "Nie masz do tego uprawnień",
    "INVITATION_INVALID": "Link zaproszenia jest nieprawidłowy.",
    "INVITATION_EXPIRED": "Link zaproszenia wygasł. Poproś swojego pracodawcę o wysłanie nowego.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "To zatrudnienie jest już powiązane z innym kontem.",
    "EMPLOYMENT_NOT_INVITABLE": "Tego zatrudnienia nie można już zaakceptować.",
    "PERSON_BINDING_CONFLICT": "Ten rekord osoby jest powiązany z innym kontem w aplikacji. Skontaktuj się z administratorem.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Ten pracownik nie spełnia wymagań, więc wpuszczenie go trzeba zarejestrować jako wyjątek.",
    "PERSON_NOT_BOUND": "Ta osoba nie ma jeszcze konta w aplikacji.",
    "PERSON_NO_PROJECT_ACCESS": "Zeskanowana osoba nie ma dostępu do tego projektu",
    "PERSON_ALREADY_CHECKED_IN": "Zeskanowana osoba jest już zameldowana w tym projekcie",
    "SUBJECT_NOT_FOUND": "Nie znaleziono konta zeskanowanej osoby",
    "SUBJECT_NOT_CHECKED_IN": "Ten pracownik nie jest zameldowany na tym projekcie, więc nie można go tu wpuścić"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Skanowanie",
    "SCAN_QR_CODE": "Skanuj kod QR",
    "RETRY_SCAN_QR_CODE": "Skanuj kod QR ponownie",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Otwórz ustawienia i nadaj uprawnienie do użycia aparatu",
    "OPEN_SETTINGS": "Otwórz ustawienia",
    "SCAN_AGAIN": "Skanuj kolejny",
    "VERIFY_AGAINST": "Weryfikuj dla projektu",
    "VERIFY_AGAINST_PLACEHOLDER": "Wybierz projekt"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Wybierz opcję",
    "DEFAULT_MULTISELECT_TITLE": "Wybierz jedną lub więcej opcji"
  },
  "ONBOARDING": {
    "LOG_IN": "Zaloguj się",
    "WELCOME_MESSAGE": "Witaj na platformie edukacyjnej i rozwojowej."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Dokończ tworzenie konta",
    "DESCRIPTION": "Otrzymaliśmy Twoje dane tożsamości od Yivi. Uzupełnij pozostałe informacje iLOP, aby kontynuować.",
    "BIRTH_DATE": "Data urodzenia",
    "GENDER": "Płeć",
    "SUBMIT": "Utwórz konto",
    "CANCEL": "Anuluj"
  },
  "GENDER": {
    "MALE": "Mężczyzna",
    "FEMALE": "Kobieta",
    "OTHER": "Inna"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Zapisane"
  },
  "NOTIFICATION": {
    "DISMISS": "Zamknij"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Informacje osobiste",
    "NAME": "Imię",
    "SURNAME": "Nazwisko",
    "NICKNAME": "Preferowane imię",
    "NICKNAME_PLACEHOLDER": "Wpisz preferowane imię (opcjonalnie)",
    "CERTIFICATES": "Certyfikaty",
    "SAVE": "Zapisz",
    "SELECT_FUNCTION": "Wybierz funkcję",
    "LOGOUT": "Wyloguj się",
    "TOAST": {
      "SAVED": "Informacje osobiste zostały zapisane",
      "ERROR": "Wystąpił błąd podczas zapisywania informacji osobistych"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Co chcesz zrobić?",
      "CHANGE_LABEL": "Zmień zdjęcie profilowe",
      "DELETE_LABEL": "Usuń zdjęcie profilowe",
      "CANCEL_LABEL": "Anuluj",
      "RESIZE_ERROR": "Nie udało się przetworzyć zdjęcia. Wybierz inne zdjęcie.",
      "CROP_TITLE": "Przytnij zdjęcie",
      "CROP_CONFIRM": "Użyj zdjęcia",
      "CROP_ZOOM_LABEL": "Powiększenie"
    },
    "SETTINGS": "Ustawienia",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Zmień hasło"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Obecne hasło",
      "PLACEHOLDER_CURRENT": "Wpisz swoje obecne hasło",
      "LABEL_NEW": "Nowe hasło",
      "PLACEHOLDER_NEW": "Wpisz swoje nowe hasło",
      "LABEL_VERIFY_NEW": "Potwierdź nowe hasło",
      "PLACEHOLDER_VERIFY_NEW": "Wpisz ponownie swoje nowe hasło",
      "BUTTON_LABEL": "Zmień hasło",
      "TOAST": {
        "SUCCESS": "Hasło zostało zmienione. Zaloguj się ponownie używając nowego hasła",
        "ERROR": "Wystąpił błąd podczas zmiany hasła"
      },
      "FORM_VALIDATION_MISMATCH": "Nowe hasła nie pasują do siebie"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Szczegóły projektu",
    "SWI_SIGNED": "SWI podpisana",
    "SWI_OPEN": "SWI otwarta",
    "SWI_SIGNED_COUNT": "{count} SWI podpisanych",
    "SWI_SIGNED_OF": "{signed} z {total} SWI podpisanych",
    "REPORT_SAFETY_RISKS": "Zgłoś zagrożenia bezpieczeństwa",
    "SEE_SAFETY_REPORTS": "Otwórz zgłoszenia bezpieczeństwa",
    "CONTRACTOR": "Podwykonawca",
    "CLIENT": "Klient",
    "SELECT": "Wybierz",
    "WORKERS": "Pracownicy",
    "DESELECT": "Odznacz",
    "WORKERS_EMPTY_STATE": "Żaden pracownik nie zarejestrował się jeszcze do tego projektu.",
    "UNKNOWN_EMPLOYER": "Pracodawca nieznany",
    "CERTIFICATES": "Wymagane certyfikaty projektu",
    "TOOLBOXES": "Wymagane toolboxes projektu",
    "TOOLBOXES_ALL_COMPLETED": "Wszystkie wymagane toolboxes zostały ukończone",
    "ALERTS": "Wiadomości",
    "CREATE_ALERT": "Dodaj wiadomość",
    "ALERTS_EMPTY_STATE": "Obecnie nie ma wiadomości dla tego projektu",
    "MAIN_OFFICE": "Siedziba główna",
    "CHECK_IN": "Zamelduj się",
    "CHECK_OUT": "Wymelduj się",
    "AT_WORK": "{count} w pracy",
    "REQUIREMENTS_CHECKLIST": "Wymagania projektu",
    "OVERWRITE_CHECKIN_TITLE": "Zamelduj się",
    "OVERWRITE_CHECKIN_MESSAGE": "Jesteś obecnie zameldowany w \"{projectName}\". Zameldowanie się tutaj zakończy tamto zameldowanie.",
    "OVERWRITE_CHECKIN_CONFIRM": "Zamelduj się",
    "OVERWRITE_CHECKIN_CANCEL": "Anuluj"
  },
  "PROJECT_SELECT": {
    "TITLE": "Wybierz projekt",
    "PROJECT_NAME": "Nazwa projektu",
    "PROJECT_FUNCTION": "Funkcja w projekcie",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Wybierz co najmniej jedną funkcję.",
    "EMPLOYEE": "Pracownik",
    "NEXT": "Dalej",
    "ALREADY_CHECKED_IN_TITLE": "Już zameldowany",
    "ALREADY_CHECKED_IN_MESSAGE": "Jesteś już zameldowany w tym projekcie. Nie musisz nic robić.",
    "INVALID_CODE": "Ten kod projektu nie jest już ważny. Poproś kierownika budowy o aktualny kod.",
    "REPORT_TO_FOREMAN_TITLE": "Zgłoś się do kierownika budowy",
    "REPORT_TO_FOREMAN_MESSAGE": "Jesteś zameldowany, ale nie jesteś przypisany do tego projektu. Zgłoś się natychmiast do kierownika budowy."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Wszystkie wymagania są spełnione",
    "BUTTON": "Potwierdź",
    "TITLE": "Potwierdź wybór projektu"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Sukces!",
    "SELECTED": "Zarejestrowałeś się w projekcie.",
    "DESELECTED": "Wyrejestrowałeś się z projektu.",
    "BUTTON": "Główna"
  },
  "CERTIFICATE": {
    "EXPIRED": "Wygasł {date}",
    "VALID_UNTIL": "Ważny do {date}",
    "EXPIRES_IN": "Wygasa za {duration}",
    "EXPIRES_SOON": "Wygasa w ciągu 3 miesięcy",
    "EXPIRES_NEVER": "Nigdy nie wygasa",
    "MISSING": "Jeszcze nie uzyskano",
    "PENDING": "Oczekuje na weryfikację",
    "REJECTED": "Odrzucone",
    "VIEW_DOCUMENT": "Dokument",
    "VIEW_DOCUMENT_N": "Dokument {n}",
    "REGISTERED_TO": "Zarejestrowane na {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Dodaj zdjęcie lub PDF",
    "TAKE_PHOTO": "Zrób zdjęcie",
    "CHOOSE_FROM_LIBRARY": "Wybierz z biblioteki",
    "CHOOSE_PDF": "Wybierz PDF",
    "REMOVE": "Usuń",
    "CANCEL": "Anuluj"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Dodaj certyfikat",
    "CERTIFICATE": "Certyfikat",
    "CERTIFICATE_NUMBER": "Numer certyfikatu",
    "ISSUED_ON": "Wydano dnia",
    "EXPIRES_ON": "Wygasa",
    "DOCUMENT": "Dokument",
    "MISSING_FIELDS": "Wybierz organizację i certyfikat.",
    "ERROR": "Coś poszło nie tak. Spróbuj ponownie.",
    "CHOOSER": {
      "IMPORT": "Importuj z rejestru",
      "UPLOAD": "Prześlij dokument"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Importuj certyfikat",
    "LAST_NAME": "Nazwisko",
    "DATE_OF_BIRTH": "Data urodzenia",
    "REGISTRY": "Rejestr",
    "CERTIFICATE_NUMBER": "Numer certyfikatu",
    "MISSING_FIELDS": "Wypełnij wszystkie pola.",
    "SUCCESS": "Certyfikat zaimportowany.",
    "STATUS": {
      "NOTFOUND": "Nie znaleziono certyfikatu dla tych danych.",
      "REGISTRYERROR": "Nie można teraz połączyć się z rejestrem. Spróbuj ponownie później."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Nie znaleziono certyfikatów",
    "EXPIRED_CERTIFICATES": "Niektóre z Twoich certyfikatów wygasły. Odnów je, aby kontynuować pracę."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Warunki korzystania",
    "PRIVACY_POLICY": "Polityka prywatności",
    "APP_INFO": "Informacje o aplikacji",
    "AVG_STATEMENT": "Oświadczenie RODO"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{miesiąc} few{miesiące} other{miesięcy}}",
    "DAYS": "{count, plural, =1{dzień} other{dni}}",
    "SOON": "wkrótce"
  },
  "PERSON": {
    "FIRST_NAME": "Imię",
    "LAST_NAME": "Nazwisko",
    "EMAIL": "Adres e-mail",
    "FUNCTION": "Funkcja"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Funkcja",
    "PROJECT": "Bieżący projekt",
    "CERTIFICATES": "Certyfikaty",
    "PROJECT_DETAILS": "Szczegóły projektu",
    "UPDATE_PERSON_ACTION": "Edytuj szczegóły",
    "ASSIGN_TO_PROJECT_ACTION": "Przypisz do mojego projektu"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Wybierz zdjęcie profilowe",
    "CANCEL": "Anuluj",
    "TAKE_PHOTO": "Zrób zdjęcie",
    "CHOOSE_FROM_LIBRARY": "Wybierz z biblioteki"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Moje zgłoszenia",
      "EMPTY_STATE_TITLE": "Brak zgłoszeń",
      "EMPTY_STATE_MESSAGE": "Zagrożenia bezpieczeństwa, które sam zgłosiłeś, pojawią się tutaj.",
      "CREATE_REPORT": "Utwórz zgłoszenie"
    },
    "REPORT": {
      "ASSIGNED_TO": "Obsługiwane przez {name}",
      "REPORTED_BY": "Zgłoszone przez {name}",
      "REPORTED_BY_ANONYMOUS": "Zgłoszone anonimowo"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Zgłoszenia dla {projectName}",
      "EMPTY_STATE_TITLE": "Brak zgłoszeń",
      "EMPTY_STATE_MESSAGE": "Zagrożenia bezpieczeństwa zgłoszone w tym projekcie pojawią się tutaj."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Nie można utworzyć zgłoszenia",
      "DESCRIPTION": "Nie jesteś zarejestrowany w projekcie. Zarejestruj się, aby móc utworzyć zgłoszenie."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Utwórz zgłoszenie",
      "GENERAL": {
        "FORM_TITLE": "Ogólne",
        "CATEGORY": "Co chciałbyś zgłosić?",
        "IS_SOLVED": "Czy jest rozwiązane?",
        "IS_URGENT": "Pilność",
        "IS_ANONYMOUS": "Zgłoś anonimowo",
        "PROJECT": "W którym projekcie chciałbyś złożyć to zgłoszenie?",
        "NO_PROJECTS": "Nie jesteś zarejestrowany w projekcie. Zarejestruj się, aby móc utworzyć zgłoszenie.",
        "CHOOSE_PROJECT": "Wybierz projekt",
        "CONFIRM_PROJECT": "Nie jesteś zarejestrowany w tym projekcie. Czy na pewno chcesz złożyć to zgłoszenie?",
        "CONFIRM_PROJECT_BUTTON": "Tak, jestem pewny",
        "VICTIMS": "Ofiary?",
        "ABSENTEEISM": "Nieobecność",
        "HOSPITALISED": "Hospitalizowani?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "W PRZYPADKU POWAŻNEGO WYPADKU LUB URAZU WYMAGAJĄCEGO HOSPITALIZACJI, ZAWSZE NAJPIERW ZADZWOŃ DO SŁUŻB RATUNKOWYCH",
          "BETWEEN_PHONE_AND_URL": "LUB ZA POŚREDNICTWEM FORMULARZA ONLINE:",
          "AFTER_LINK": "Skonsultuj się z przełożonym, brygadzistą lub koordynatorem V&G odpowiedzialnym za ten raport."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Sytuacja",
        "PHOTOS": "Jak wygląda sytuacja?",
        "PHOTOS_PLACEHOLDER": "Dodaj jedno lub więcej zdjęć albo wypełnij opis",
        "DESCRIPTION": "Opisz sytuację",
        "SAFE_SITUATION_DESCRIPTION": "Bezpieczna sytuacja",
        "RISK": "Zagrożenie",
        "DESCRIPTION_OF_SITUATION": "Opis sytuacji",
        "ACTIONS_TAKEN": "Podjęte działania",
        "RISK_CATEGORY": {
          "LABEL": "Kategoria zagrożenia",
          "PLACEHOLDER": "Wybierz kategorię",
          "REQUIRED": "Kategoria jest wymagana"
        }
      },
      "SUMMARY": {
        "TITLE": "Zgłoszenie wysłane",
        "MESSAGE": "Zgłoszenie o numerze #{{id}} zostało wysłane."
      },
      "SEND": "Wyślij",
      "SUCCESS_TOAST": "Zgłoszenie bezpieczeństwa zostało pomyślnie utworzone",
      "VALIDATION": {
        "MISSING_FIELDS": "Uzupełnij wszystkie wymagane pola"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Nie przypisano do pracownika",
      "ASSIGNED_TO_PERSON": "Przypisany do pracownika",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Przypisz do pracownika",
      "DETAILS": "Szczegóły",
      "TITLE": "Zobacz zgłoszenie {reportId}",
      "PROJECT_NAME": "Projekt",
      "REPORTER": "Zgłaszający",
      "ANONYMOUS_REPORTER": "Anonimowy zgłaszający",
      "UNKNOWN_AUTHOR": "Nieznany autor",
      "CATEGORY": "Typ zgłoszenia",
      "URGENCY": "Pilność",
      "SOLVED": "Rozwiązane",
      "PHOTOS": "Zdjęcia",
      "PHOTOS_EMPTY": "To zgłoszenie nie zawiera zdjęć",
      "DESCRIPTION": "Opis",
      "RISK": "Zagrożenie",
      "CREATED_AT": "Utworzone dnia",
      "CREATE_COMMENT": "Dodaj komentarz",
      "COMMENTS": "Komentarze",
      "COMMENTS_EMPTY": "Nie dodano jeszcze żadnych komentarzy",
      "COMMENT_BY": "Komentarz od {person}",
      "COMMENT_CREATED": "Komentarz został pomyślnie dodany",
      "LOGS": "Logi",
      "LOGS_EMPTY": "Nie ma jeszcze żadnych logów",
      "LOG": {
        "CREATED": "Zgłoszenie utworzone przez {actor}",
        "STATUS_CHANGED": "Status zmieniony na {newStatus} przez {actor}",
        "COMMENTED": "Komentarz dodany przez {actor}"
      },
      "NOT_IN_PROJECT": "Zgłaszający nie był zarejestrowany w tym projekcie"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Zamknij",
    "OPEN": "Otwórz"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Wypadek",
    "UNSAFE_SITUATION": "Sytuacja niebezpieczna",
    "SAFE_SITUATION": "Sytuacja bezpieczna"
  },
  "REPORT_STATUS": {
    "NEW": "Nieprzeczytane",
    "IN_PROGRESS": "W trakcie",
    "SOLVED": "Rozwiązane",
    "ON_HOLD": "Wstrzymane"
  },
  "NOTIFICATIONS": {
    "TITLE": "Powiadomienia",
    "EMPTY_STATE_TITLE": "Brak powiadomień",
    "EMPTY_STATE_MESSAGE": "Tutaj znajdziesz wszystkie ważne powiadomienia z teraźniejszości i przeszłości",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Oznacz jako przeczytane",
    "MARK_ALL_AS_READ": "Oznacz wszystkie jako przeczytane",
    "MARK_ALL_AS_READ_SUCCESS": "Wszystkie powiadomienia oznaczono jako przeczytane",
    "DELETE": "Usuń",
    "DELETE_SUCCESS": "Powiadomienie usunięte"
  },
  "REPORT_TRANSITION": {
    "NEW": "Powrót do otwartego",
    "IN_PROGRESS": "Rozpocznij",
    "SOLVED": "Oznacz jako rozwiązane",
    "ON_HOLD": "Wstrzymaj",
    "SOLVED_CONFIRMATION_TITLE": "Oznaczyć zgłoszenie jako rozwiązane?",
    "SOLVED_CONFIRMATION_MESSAGE": "Czy na pewno chcesz oznaczyć to zgłoszenie jako rozwiązane?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Powiedz swój tekst",
    "BTN_LABEL": "Powiedz tekst",
    "PERMISSION_ERROR": "Nie można powiedzieć tekstu. Nie nadano uprawnienia. Otwórz ustawienia telefonu i nadaj uprawnienie do mówienia tekstu dla tej aplikacji.",
    "LISTENING": "Słucham...",
    "USE_RESULT": "Zachowaj"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Nie uzyskałeś jeszcze żadnych certyfikatów",
    "PERSON_EMPTY_STATE": "Ten pracownik nie uzyskał jeszcze żadnych certyfikatów",
    "PROJECT_EMPTY_STATE": "Nie ma odpowiednich certyfikatów dla tego projektu",
    "PERSON_PROJECT_EMPTY_STATE": "Nie ma odpowiednich certyfikatów dla tego pracownika w tym projekcie"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Ogólne",
    "WEATHER": "Pogoda",
    "LOGISTIC": "Logistyka",
    "SAFETY": "Bezpieczeństwo"
  },
  "ALERT_DETAILS": {
    "EDIT": "Edytuj",
    "TITLE": "Szczegóły wiadomości",
    "CONFIRM": "Zrozumiano",
    "DELETE_TITLE": "Usuń wiadomość",
    "DELETE_MESSAGE": "Czy na pewno chcesz usunąć tę wiadomość?",
    "DELETE_CONFIRM": "Usuń",
    "DELETE_SUCCESS": "Wiadomość usunięta"
  },
  "ALERT_PLAYER": {
    "PLAY": "Odtwórz",
    "PAUSE": "Wstrzymaj",
    "LANGUAGE": "Język",
    "SEEK": "Postęp",
    "FULLSCREEN": "Pełny ekran"
  },
  "ALERT": {
    "CATEGORY": "Kategoria",
    "TITLE": "Tytuł",
    "DESCRIPTION": "Opis",
    "VALID_FROM": "Od",
    "VALID_UNTIL": "Do",
    "FROM": "od",
    "UNTIL": "do",
    "VIDEO": "Wideo",
    "REMOVE_VIDEO": "Usuń wideo",
    "TYPE": "Typ wiadomości",
    "TYPE_TEXT": "Tekst",
    "TYPE_VIDEO": "Wideo",
    "ADD_TARGET_AUDIENCE": "Dodaj grupę docelową",
    "TARGET_AUDIENCE": "Grupa docelowa",
    "TARGET_AUDIENCE_EVERYONE": "Wszyscy",
    "TARGET_AUDIENCE_MANAGEMENT": "Kierownictwo",
    "SELECT_TARGET_AUDIENCE": "Wybierz grupę docelową",
    "NO_FILE_SELECTED": "Nie wybrano pliku",
    "CHOOSE_FILE": "Wybierz plik",
    "TRANSLATION": "Tłumaczenie",
    "TRANSLATION_DESCRIPTION": "Przetłumacz to wideo",
    "VIDEO_UPLOAD_FAILED": "Przesyłanie wideo nie powiodło się",
    "AUDIENCE": {
      "MANAGEMENT": "Kierownictwo",
      "ORGANISATION": "Organizacja:",
      "FUNCTION": "Funkcja:",
      "FUNCTION_GROUP": "Grupa funkcji:",
      "ADD_MANAGEMENT": "Kierownictwo",
      "ADD_ORGANISATION": "Organizacja",
      "ADD_FUNCTION": "Funkcja lub grupa",
      "SELECT_ORGANISATION": "Wybierz organizację",
      "NO_ORGANISATIONS": "Brak organizacji w tym projekcie.",
      "LOADING_ORGANISATIONS": "Wczytywanie..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Dodaj wiadomość",
    "ACTION": "Utwórz wiadomość",
    "SUCCESS_TOAST_MESSAGE": "Wiadomość została utworzona pomyślnie"
  },
  "EDIT_ALERT": {
    "TITLE": "Edytuj wiadomość",
    "ACTION": "Zapisz zmiany",
    "SUCCESS_TOAST_MESSAGE": "Wiadomość została zaktualizowana pomyślnie"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Przypisz projekt",
    "SUCCESS_TOAST_MESSAGE": "Projekt został przypisany"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Przypisz projekt",
    "SUCCESS_TOAST_MESSAGE": "Projekt został przypisany"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Szukaj opcji"
  },
  "CHECKLIST": {
    "COMPLETED": "Lista kontrolna została pomyślnie ukończona",
    "ERROR": "Coś poszło nie tak podczas ukończenia listy kontrolnej",
    "LIST_LABEL": "Listy kontrolne",
    "ALL_COMPLETED": "Wszystkie wymagane listy kontrolne zostały ukończone",
    "COMPLETE": "Ukończ"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Wymagania hasła:",
    "MIN_LENGTH": "Co najmniej {minLength} znaków",
    "UPPERCASE": "Co najmniej jedna wielka litera",
    "LOWERCASE": "Co najmniej jedna mała litera",
    "DIGIT": "Co najmniej jedna cyfra",
    "SPECIAL_CHAR": "Co najmniej jeden znak specjalny"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Główny",
    "SEARCH_PLACEHOLDER": "Szukaj funkcji",
    "NO_RESULTS": "Nie znaleziono funkcji",
    "WHOLE_CATEGORY": "Cała grupa: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Podpisano {moment}",
    "NO_SWI_SIGNATURE": "Jeszcze nie podpisano",
    "SWI_SIGNATURE_ALT": "Podpis",
    "SWI_SIGNATURE_FAILED": "Nie udało się wczytać podpisu",
    "TITLE": "Dane pracownika",
    "ITEM_STATUS": {
      "PRESENT": "Posiadane",
      "MISSING": "Brak",
      "EXPIRED": "Wygasłe",
      "EXPIRED_GRACE_PERIOD": "Wygasłe (okres karencji)"
    },
    "CERTIFICATES": "Certyfikaty",
    "CHECKLISTS": "Listy kontrolne",
    "SAFETY_INSTRUCTIONS": "Instrukcje bezpieczeństwa",
    "TOOLBOXES": "Zestawy narzędzi",
    "NAME": "Imię i nazwisko",
    "VERIFIED_AGAINST": "Zweryfikowano dla {project}",
    "BASIC_INFORMATION": "Informacje podstawowe",
    "ILOP_CONTENT": "Treści i-LOP",
    "NO_EMPLOYMENTS": "Ten pracownik nie ma aktywnych zatrudnień",
    "NO_ILOP_CONTENT": "Brak odpowiednich treści i-LOP dla tego pracownika w tym projekcie",
    "CHECK_IN": {
      "SINCE": "Zameldowano o"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Funkcja",
      "FROM": "Od",
      "TO": "Do"
    },
    "CERTIFICATE": {
      "NUMBER": "Numer",
      "ISSUED_ON": "Data wydania",
      "ISSUED_FOR": "Wydany dla",
      "EXPIRES_ON": "Wygasa"
    },
    "CONTENT": {
      "COMPLETED_ON": "Ukończono",
      "MEETING_ENDED": "Zakończenie spotkania",
      "SIGNED": "Podpisano"
    },
    "KVK": {
      "NUMBER": "Numer KvK",
      "DOCUMENT_DATE": "Wyciąg z dnia",
      "VALID_UNTIL": "Ważny do",
      "DOCUMENT": "Wyciąg KvK"
    },
    "OPEN_DOCUMENT": "Otwórz",
    "OPEN_DOCUMENT_FAILED": "Nie udało się otworzyć dokumentu"
  },
  "GATE_ENTRY": {
    "TITLE": "Zarejestruj wejście",
    "GAPS_HINT": "Ten pracownik nie spełnia wymagań, więc wpuszczenie go jest wyjątkiem.",
    "NOT_CHECKED_IN_HINT": "Ten pracownik nie jest zameldowany na tym projekcie. Zamelduj go, aby go wpuścić, albo odmów wejścia.",
    "CHECK_IN_WORKER": "Zamelduj pracownika",
    "DECISION": {
      "VALID": "Ważne",
      "EXCEPTION": "Wyjątek",
      "DENIED": "Odmowa"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Powód wyjątku",
      "HEADER_DENIED": "Powód odmowy wejścia",
      "MESSAGE": "Zostanie to zapisane z Twoim imieniem i godziną.",
      "PLACEHOLDER": "Opisz powód",
      "CONFIRM": "Zarejestruj"
    },
    "REGISTERED": "Wejście zarejestrowane"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Historia zatrudnienia",
      "NO_EMPLOYMENTS": "Brak dostępnej historii zatrudnienia.",
      "PRESENT": "Obecnie",
      "ACTIVE": "Aktywny",
      "NOT_YET_ACTIVE": "Jeszcze nieaktywne",
      "LOAD_ERROR": "Wystąpił błąd podczas ładowania historii zatrudnienia.",
      "STATUS_FOR_ADMIN_REVIEW": "W trakcie weryfikacji",
      "STATUS_FOR_USER_REVIEW": "Zweryfikuj swoje zatrudnienie",
      "ADD_EMPLOYMENT": "Dodaj",
      "REVIEW_NOTICE": "Istnieją zatrudnienia oczekujące na Twoją weryfikację.",
      "REVIEW_NOTICE_ACTION": "Kliknij, aby je wyświetlić i zweryfikować.",
      "REVIEW_OPEN": "Zweryfikuj",
      "REVIEW_DETAILS_TITLE": "Zweryfikuj zatrudnienie",
      "FUNCTION": "Funkcja",
      "START_DATE": "Data rozpoczęcia",
      "END_DATE": "Data zakończenia",
      "MANAGERIAL": "Funkcja kierownicza",
      "YES": "Tak",
      "NO": "Nie",
      "ACCEPT": "Akceptuj",
      "REJECT": "Odrzuć",
      "REVIEW_ACCEPT_SUCCESS": "Zatrudnienie zostało pomyślnie zaakceptowane.",
      "REVIEW_REJECT_SUCCESS": "Zatrudnienie zostało pomyślnie odrzucone.",
      "REVIEW_ERROR": "Wystąpił błąd podczas weryfikacji zatrudnienia."
    },
    "DETAIL": {
      "TITLE": "Zatrudnienie",
      "NOT_FOUND": "Nie znaleziono tego zatrudnienia."
    },
    "CREATE": {
      "TITLE": "Dodaj zatrudnienie",
      "ORGANISATION": "Organizacja",
      "SEARCH_ORGANISATION": "Szukaj organizacji",
      "NO_ORGANISATIONS": "Nie znaleziono organizacji.",
      "FUNCTION": "Funkcja",
      "START_DATE": "Data rozpoczęcia",
      "END_DATE": "Data zakończenia",
      "MANAGERIAL_LABEL": "Funkcja kierownicza",
      "BUSINESS_REGISTRY_NUMBER": "Numer rejestru handlowego",
      "SAVE": "Zapisz",
      "SAVE_SUCCESS": "Zatrudnienie dodane pomyślnie.",
      "SAVE_ERROR": "Wystąpił błąd podczas dodawania zatrudnienia.",
      "LOAD_ORGANISATIONS_ERROR": "Wystąpił błąd podczas ładowania organizacji.",
      "END_DATE_BEFORE_START": "Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.",
      "ORGANISATION_UNAVAILABLE": "Ten pracodawca nie jest już dostępny. Wybierz innego.",
      "FUNCTION_UNKNOWN": "Ta funkcja nie jest już dostępna. Wybierz inną.",
      "BINDING_CONFLICT": "Ten pracodawca zna już osobę z Twoim adresem e-mail, na innym koncie. Poproś go, aby zamiast tego wysłał Ci zaproszenie.",
      "IDENTITY_INCOMPLETE": "Na Twoim koncie brakuje imienia i nazwiska lub adresu e-mail, więc pracodawca nie może Cię jeszcze zarejestrować. Zaloguj się przez Yivi, aby je uzupełnić.",
      "REQUEST_ALREADY_PENDING": "Masz już oczekującą prośbę u tego pracodawcy. Poczekaj na jego odpowiedź.",
      "INVITATION_PENDING": "Ten pracodawca już Cię zaprosił. Zaakceptuj lub odrzuć to zaproszenie w swojej historii zatrudnienia."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Lista",
      "REGISTRATION": "Rejestracja"
    },
    "EMPTY_STATE": "Brak dostępnych narzędzi",
    "LAST_UPDATED": "Zaktualizowane",
    "VIEW_DOCUMENT": "Zobacz dokument",
    "ASYNC": {
      "COMPLETED": "Toolbox zakończony",
      "ERROR_COMPLETING": "Nie udało się zakończyć toolboxa"
    },
    "FOLLOWED": {
      "TITLE": "Ukończone toolboxy",
      "LINK": "Zobacz ukończone toolboxy",
      "FILTER_CATEGORY": "Kategoria",
      "FILTER_TYPE": "Rodzaj",
      "TYPE_SYNCHRONOUS": "Synchroniczny",
      "TYPE_ASYNCHRONOUS": "Asynchroniczny",
      "TYPE_MANUAL": "Ręczny",
      "NOT_AVAILABLE": "Już niedostępny",
      "EMPTY_STATE": "Nie ukończyłeś jeszcze żadnego toolboxa",
      "EMPTY_FILTERED": "Żaden ukończony toolbox nie pasuje do tych filtrów"
    },
    "MEETING": {
      "HOST_MEETING": "Rozpocznij spotkanie toolbox",
      "START_ANOTHER_TITLE": "Rozpocząć kolejne spotkanie?",
      "START_ANOTHER_MESSAGE": "Masz już {count, plural, =1{jedno trwające spotkanie toolbox} few{# trwające spotkania toolbox} other{# trwających spotkań toolbox}}. Rozpocząć kolejne?",
      "START_ANOTHER_CONFIRM": "Rozpocznij kolejne",
      "ONLY_MANAGERIAL_CAN_HOST": "Tylko kierownicy mogą prowadzić spotkanie toolbox",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Tylko kierownicy mogą zarządzać spotkaniem toolbox",
      "VIEW_ACTIVE_MEETING": "Zobacz aktywne spotkanie",
      "SELECT_ACTIVE_MEETING": "Wybierz spotkanie",
      "MANUAL": {
        "START_BUTTON": "Rozpocznij ręczne spotkanie",
        "DESCRIPTION": "Rozpocznij nowe ręczne spotkanie toolbox dla swojego zespołu jako kierownik.",
        "START_TITLE": "Rozpocznij ręczne spotkanie",
        "ORGANISATION": "Organizacja",
        "ORGANISATION_PLACEHOLDER": "Wybierz organizację",
        "TITLE": "Tytuł",
        "TITLE_PLACEHOLDER": "Wpisz tytuł",
        "DESCRIPTION_PLACEHOLDER": "Opcjonalny opis",
        "START_MISSING_FIELDS": "Uzupełnij wszystkie wymagane pola",
        "TITLE_REQUIRED": "Tytuł jest wymagany",
        "TITLE_NOT_ALLOWED": "Tytuł można zmienić tylko dla ręcznych spotkań",
        "END_BEFORE_START": "Czas zakończenia nie może być wcześniejszy niż czas rozpoczęcia",
        "ACTIVE_LIST_TITLE": "Twoje spotkania toolbox",
        "ACTIVE_BADGE": "W toku",
        "PLANNED_BADGE": "Zaplanowane",
        "CONTINUE_BUTTON": "Kontynuuj to spotkanie"
      },
      "TITLE": "Spotkanie toolbox",
      "PARTICIPANTS": "Uczestnicy",
      "NO_PARTICIPANTS": "Brak uczestników",
      "EXTERNAL_PARTICIPANT": "zewnętrzny",
      "INFORMATION": "Informacje",
      "START_DATE": "Data rozpoczęcia",
      "END_DATE": "Data zakończenia",
      "DESCRIPTION": "Opis",
      "FINISH_MEETING": "Zakończ spotkanie",
      "EDIT_MEETING": "Edytuj spotkanie",
      "SAVE": "Zapisz",
      "CANCEL": "Anuluj",
      "FINISH_CONFIRMATION_TITLE": "Zakończyć spotkanie?",
      "FINISH_CONFIRMATION_MESSAGE": "Czy na pewno chcesz zakończyć to spotkanie toolbox?",
      "MEETING_ENDED_TITLE": "Spotkanie zakończone",
      "MEETING_ENDED_MESSAGE": "To spotkanie zostało zakończone {endTime} przez {finishedByName}",
      "MEETING_ALREADY_STARTED": "Spotkanie zostało już rozpoczęte przez inną osobę",
      "ERROR_POLLING_MEETING": "Wystąpił błąd podczas sprawdzania spotkań",
      "ERROR_STARTING_MEETING": "Nie udało się rozpocząć spotkania",
      "ERROR_LOADING_MEETING": "Nie udało się wczytać spotkania",
      "ERROR_UPDATING_MEETING": "Nie udało się zaktualizować spotkania",
      "ERROR_FINISHING_MEETING": "Nie udało się zakończyć spotkania",
      "ERROR_END_BEFORE_START": "Czas zakończenia nie może być wcześniejszy niż czas rozpoczęcia",
      "SCAN_QR_CODE": "Skanuj kod QR",
      "RETRY_SCAN": "Skanuj ponownie",
      "SCAN_TO_JOIN": "Skanuj, aby dołączyć",
      "JOIN_TOOLBOX_MEETING": "Dołącz do spotkania toolbox",
      "JOIN_DESCRIPTION": "Dołącz do istniejącego spotkania toolbox, skanując kod QR lub wpisując kod spotkania.",
      "QR_SCAN_WRONG_MEETING": "Ten kod QR jest dla innego spotkania",
      "QR_SCAN_ALREADY_PARTICIPANT": "Jesteś już uczestnikiem tego spotkania",
      "QR_SCAN_INVALID": "Nieprawidłowy format kodu QR",
      "QR_SCAN_ERROR": "Wystąpił błąd podczas skanowania",
      "QR_SCAN_NO_PERMISSION": "Wymagane jest zezwolenie na kamerę do skanowania kodów QR",
      "SUCCESSFULLY_JOINED": "Pomyślnie dołączono do spotkania",
      "ADD_PARTICIPANT": {
        "TITLE": "Dodaj uczestnika",
        "CHOOSE_METHOD": "Wybierz sposób dodania uczestnika do tego spotkania toolbox: zeskanuj ich kod QR i-LOP lub ręcznie wprowadź imię",
        "SCAN_QR_CODE": "Skanuj kod QR",
        "MANUAL": "Ręcznie",
        "MANUAL_ENTRY": "Wprowadzanie ręczne",
        "OR": "lub",
        "FIRST_NAME": "Imię",
        "LAST_NAME": "Nazwisko",
        "FIRST_NAME_PLACEHOLDER": "Wprowadź imię",
        "LAST_NAME_PLACEHOLDER": "Wprowadź nazwisko",
        "CONFIRM": "Potwierdź",
        "ADDING": "Dodawanie...",
        "SUCCESS": "Uczestnik został pomyślnie dodany",
        "ERROR": "Nie udało się dodać uczestnika",
        "MEETING_NOT_FOUND": "Nie znaleziono spotkania",
        "ALREADY_PARTICIPANT": "Ta osoba jest już uczestnikiem spotkania",
        "MEETING_INACTIVE": "Spotkanie nie jest aktywne",
        "QR_VERIFY_PERMISSION_ERROR": "Nie masz uprawnień do weryfikacji tego kodu QR. Zamiast tego użyj wprowadzania ręcznego.",
        "MISSING_PARAMETERS": "Brakujące wymagane parametry do nawigacji",
        "NAVIGATION_ERROR": "Nie udało się przejść do strony dodawania uczestników",
        "PERSON_NOT_IN_ORGANISATION": "Skanowana osoba nie należy do Twojej organizacji",
        "PERSON_NOT_BOUND": "Ta osoba nie ma jeszcze konta w aplikacji. Dodaj ją jako uczestnika zewnętrznego.",
        "PERSON_BINDING_CONFLICT": "Ta osoba jest powiązana z wieloma kontami w aplikacji i nie można jej dodać. Skontaktuj się z administratorem.",
        "NO_PERSON_RECORD": "Ten pracownik ma konto, ale nie jest jeszcze zatrudniony w organizacji, więc nie można go dodać jako uczestnika. Dodaj go jako uczestnika zewnętrznego."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Podpis",
    "INSTRUCTIONS": "Proszę podpisać poniżej",
    "CLEAR": "Wyczyść",
    "CONFIRM": "Potwierdź"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Zameldowany o:",
    "LAST_CHECKED_OUT_AT": "Ostatnio wymeldowany o:",
    "NOT_CHECKED_IN": "Nie zameldowany",
    "CERTIFICATES": "Certyfikaty",
    "MORE_CERTIFICATES": "{count} więcej",
    "ADD_CERTIFICATE": "Dodaj certyfikat"
  },
  "ZZP_COMPANY": {
    "TITLE": "Profil firmy (ZZP)",
    "INTRO": "Utwórz profil dla swojej jednoosobowej firmy (ZZP).",
    "COMPANY_NAME": "Nazwa firmy",
    "KVK_NUMBER": "Numer Izby Handlowej (KvK)",
    "SAVE": "Zapisz",
    "TOAST": {
      "SAVED": "Profil firmy został zapisany",
      "ERROR": "Wystąpił błąd podczas zapisywania profilu firmy",
      "LOAD_ERROR": "Wystąpił błąd podczas ładowania profilu firmy"
    },
    "KVK_EXTRACT": {
      "LABEL": "Wyciąg KvK",
      "ADD": "Dodaj wyciąg KvK",
      "VIEW": "Zobacz wyciąg KvK",
      "REMOVE": "Usuń",
      "UPLOADED": "Wyciąg KvK został przesłany",
      "REMOVED": "Wyciąg KvK został usunięty",
      "INVALID_TYPE": "Dozwolone są tylko pliki PDF lub obrazy",
      "DOCUMENT_DATE": "Data na wyciągu KvK",
      "VALID_UNTIL": "Ważny do",
      "OUT_OF_DATE": "Ten wyciąg KvK jest za stary. Prześlij nowszy.",
      "NEEDS_DATE": "Podaj datę z wyciągu, aby był uznawany.",
      "NEEDS_DOCUMENT": "Prześlij wyciąg KvK, aby data była uznawana."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Nowa SWI",
    "STEP_OF": "Krok {step} z {total}",
    "NEXT": "Dalej",
    "LOADING": "Wczytywanie…",
    "SAVED": "Zapisano Start Werk Instructie",
    "STEP_LABEL": {
      "PERIOD": "Data lub okres",
      "MESSAGES": "Komunikaty: dzisiejsze instrukcje bezpieczeństwa",
      "INSTRUCTIONS": "Instrukcje",
      "TOOLBOXES": "Toolboxy",
      "CHECKLISTS": "Listy kontrolne",
      "SUMMARY": "Podsumowanie",
      "NEW_MESSAGE": "Nowa wiadomość"
    },
    "PERIOD": {
      "SINGLE_DAY": "Jeden dzień",
      "RANGE": "Okres",
      "DATE": "Data",
      "FROM": "Od",
      "UNTIL_INCLUSIVE": "Do dnia włącznie",
      "ONE_PER_DAY_HINT": "W tym projekcie może obowiązywać tylko jedna SWI na dzień.",
      "TAKEN_DAYS_HINT": "Zaznaczone dni mają już SWI i nie można ich wybrać.",
      "OVERLAP": "W tym okresie już obowiązuje Start Werk Instructie. Wybierz inne daty."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Komunikaty",
      "MESSAGES_HINT": "Pokazywane są tylko komunikaty typu Bezpieczeństwo. Możesz wybrać kilka.",
      "MESSAGES_EMPTY": "Brak aktualnych komunikatów bezpieczeństwa w tym projekcie.",
      "INSTRUCTIONS_HEADING": "Instrukcje",
      "INSTRUCTIONS_HINT": "Pokazywane są tylko treści oznaczone jako dostępne w SWI.",
      "INSTRUCTIONS_EMPTY": "Brak instrukcji dostępnych dla SWI.",
      "TOOLBOXES_HEADING": "Toolboxy",
      "TOOLBOXES_HINT": "Pokazywane są tylko treści oznaczone jako dostępne w SWI.",
      "TOOLBOXES_EMPTY": "Brak toolboxów dostępnych dla SWI.",
      "CHECKLISTS_HEADING": "Listy kontrolne",
      "CHECKLISTS_HINT": "Pokazywane są tylko treści oznaczone jako dostępne w SWI.",
      "CHECKLISTS_EMPTY": "Brak list kontrolnych dostępnych dla SWI.",
      "MEDIUM_VIDEO": "Wideo",
      "MEDIUM_DOCUMENT": "Do przeczytania"
    },
    "SUMMARY": {
      "CHANGE": "Zmień",
      "NOTHING_SELECTED": "Nic nie wybrano",
      "NO_CONTENT": "Wybierz co najmniej jeden komunikat, instrukcję, toolbox lub listę kontrolną.",
      "SAVE": "Zapisz",
      "PERIOD_SINGLE": "Start Werk Instructie na {date}",
      "PERIOD_RANGE": "Start Werk Instructie od {from} do {to}"
    },
    "REPEAT": {
      "HEADING": "Powtarzanie",
      "FIRST_ENTRY": "Tylko przy pierwszym wejściu na budowę",
      "EVERY_ENTRY": "Za każdym wejściem na budowę",
      "AFTER_ABSENCE": "Ponownie po nieobecności",
      "ABSENCE_DAYS": "Dłuższej niż (dni)",
      "ABSENCE_DAYS_RANGE": "Podaj liczbę od {min} do {max}."
    },
    "EDIT_TITLE": "Edytuj SWI",
    "NEW_MESSAGE": {
      "ACTION": "Nowa wiadomość (tekst lub wideo)",
      "OR_PICK": "Lub wybierz istniejące wiadomości",
      "HINT": "Okres i kategoria są pobierane ze Start Werk Instructie.",
      "ADD": "Dodaj wiadomość",
      "SAVE": "Zapisz wiadomość",
      "REMOVE": "Usuń wiadomość"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Przejdź przez wszystko poniżej, a następnie podpisz.",
      "PROGRESS": "Ukończono {done} z {total}",
      "EMPTY": "Dzisiaj nie ma nic do wykonania w tym projekcie.",
      "LOAD_FAILED": "Nie udało się wczytać Start Werk Instructie.",
      "RETRY": "Spróbuj ponownie",
      "NEXT": "Następny krok",
      "SIGN_INTRO": "Sprawdź swoje dane i podpisz.",
      "NAME": "Imię i nazwisko",
      "DATE": "Data",
      "COMPANY": "Firma",
      "FUNCTION": "Funkcja",
      "CLEAR": "Wyczyść",
      "SIGN_AND_FINISH": "Podpisz i zakończ",
      "SIGNED": "Start Werk Instructie podpisana",
      "SIGN_FAILED": "Podpisanie się nie powiodło. Spróbuj ponownie."
    },
    "CARD": {
      "HEADING": "Aktywna Start Werk Instructie",
      "STATUS_ACTIVE": "Aktywna",
      "STATUS_PLANNED": "Zaplanowana",
      "PERIOD_RANGE": "{from} do {to}",
      "REPEAT_EVERY_ENTRY": "przy każdym wejściu na budowę",
      "REPEAT_FIRST_ENTRY": "tylko przy pierwszym wejściu"
    }
  }
}
